import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-selectable-content',
  templateUrl: './selectable-content.component.html',
  styleUrls: ['./selectable-content.component.scss'],
})
export class SelectableContentComponent {
  @Input() selected = false;
  @Input() showBubble = true;
}
